import type { ColorScheme } from "@hopper-ui/styled-system";
import { useEffect, useState } from "react";

export const useSystemColorScheme = (enabled: boolean = true): ColorScheme => {
    const [colorScheme, setColorScheme] = useState<ColorScheme>(() => {
        if (!enabled) {
            return "light";
        }

        return window.matchMedia?.("(prefers-color-scheme: dark)").matches ? "dark" : "light";
    });

    useEffect(() => {
        if (!enabled) {
            return;
        }

        const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
        const handleChange = (e: MediaQueryListEvent) => {
            setColorScheme(e.matches ? "dark" : "light");
        };

        mediaQuery.addEventListener("change", handleChange);

        return () => mediaQuery.removeEventListener("change", handleChange);
    }, [enabled]);

    return colorScheme;
};
